const TestimonialTemplate = ({ testimonial, headshot, name, title }) => {
    return (
        <div className="w-full flex flex-col px-[80px] md:px-[80px] lg:px-[120px] 1.5xl:px-[300px] 3xl:px-[450px]">

            <svg 
                className="w-12 h-12 text-[#9a016a] mb-4" 
                fill="currentColor" 
                viewBox="0 0 24 24"
            >
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
            </svg>

            <p className="mb-0 font-proximanova text-[18px] md:text-[20px] leading-relaxed text-[#505050] font-[400] text-start italic">
                "{testimonial}"
            </p>

            <div className="w-fit mx-auto mt-[40px] 3xl:mt-[60px] flex flex-col sm:flex-row items-center gap-4 1.5xl:gap-[30px]">
                <div 
                    className="w-[120px] h-[120px] 1.5xl:w-[160px] 1.5xl:h-[160px] rounded-full bg-cover bg-center flex-shrink-0"
                    style={{ backgroundImage: `url(${headshot})` }}
                />
                
                <div className="flex flex-col justify-center text-center sm:text-start">
                    <h5 className="font-proximanova text-[24px] md:text-[28px] 1.5xl:text-[26px] font-[700] text-[#707070] mb-1">
                        {name}
                    </h5>
                    <p className="font-proximanova text-[16px] md:text-[18px] text-[#9a016a] font-[600]">
                        {title}
                    </p>
                </div>
            </div>
        </div>
    );
}
export default TestimonialTemplate;